import {
  FETCH_GLOBAL_IMPC_PRESET_PER_ASSET_TYPE_SUCCESS,
  FETCH_GLOBAL_OPERATOR_PRESET_PER_ASSET_TYPE_SUCCESS,
} from '../actions/types/GlobalPresetPerAssetTypeActionTypes';
import { RESET_ASSET_TYPE } from '../../../../asset-types/redux/actions/types/AssetTypesActionTypes';
import { AUTH_LOGOUT } from '../../../../redux/actions/types/authActionTypes';

export const initialState = {
  globalImpcPreset: [],
  globalOperatorPreset: [],
};

export const globalPresetPerAssetTypeReducer = (state = initialState, action) => {
  switch (action.type) {
    case FETCH_GLOBAL_IMPC_PRESET_PER_ASSET_TYPE_SUCCESS:
      return {
        ...state,
        globalImpcPreset: action.payload,
      };
    case FETCH_GLOBAL_OPERATOR_PRESET_PER_ASSET_TYPE_SUCCESS:
      return {
        ...state,
        globalOperatorPreset: action.payload,
      };
    case RESET_ASSET_TYPE: case AUTH_LOGOUT:
      return initialState;
    default:
      return state;
  }
};
